exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".vm--overlay[data-v-d5e45b9a]{background:#000;opacity:.7}.overlay-enter[data-v-d5e45b9a],.overlay-leave-to[data-v-d5e45b9a]{opacity:0}.overlay-enter-active[data-v-d5e45b9a],.overlay-leave-active[data-v-d5e45b9a]{transition:all .3s}.fade-in-enter-active[data-v-d5e45b9a],.fade-in-leave-active[data-v-d5e45b9a]{transition:opacity .3s}.fade-in-enter[data-v-d5e45b9a],.fade-in-leave-to[data-v-d5e45b9a]{opacity:0}", ""]);

// exports
